import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcntr _flexaicntr _tc--lighter gfu-bt gfu-bt--overline" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createTextVNode(" payments powered by ", -1 /* CACHED */)),
    _createVNode(_component_base_image, {
      class: "_ml-1",
      src: "/content/images/payments/logo-adyen.png",
      alt: "Adyen"
    })
  ]))
}